import { render, staticRenderFns } from "./TourTabsGuides.vue?vue&type=template&id=4143bada&"
import script from "./TourTabsGuides.vue?vue&type=script&lang=js&"
export * from "./TourTabsGuides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports